import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import PropTypes from "prop-types";

import If from "common/components/if";

/**
 * Renders a pre-formatted bulletin in a <pre> tag, or an image in a preformatted <Image> tag.
 * Can optionally render a timestamp for bulletins (but not for images)
 */
function FormattedBulletin(props) {
  let rowValue = null;
  let triggerNotamLink = ""
  if (props.data.type === "image") {
    rowValue = props.data.formattedBulletin;
  } else {
    rowValue = <pre key="bulletin">{props.data.formattedBulletin}</pre>;
    if(props.data.formattedBulletin.includes('TRIGGER NOTAM')){
      triggerNotamLink = <a rel="noopener noreferrer" target='_blank' href={window.AIP_LINK}><FormattedMessage id="aip_supplements"/></a>
    }
  }

  return (
    <React.Fragment>
      <If condition={props.data.hasError}>
        <strong key="error">
          <FormattedMessage id="geom_error" />
        </strong>
      </If>
      <div>
        {rowValue}
        {triggerNotamLink}
      </div>
    </React.Fragment>
  );
}

FormattedBulletin.propTypes = {
  // Data required to render the bulletin.
  // Keys are:
  //   - formattedBulletin [String] Fully translated and formatted bulletin text
  //   - startValidity [Object] Moment object representing the start validity of the bulletin
  //   - endValdity [Object] (Optional) Moment object representing the end validity of the bulletin
  data: PropTypes.object.isRequired,
};

export default injectIntl(FormattedBulletin);
